import { Text, View } from 'react-native';
import { StyleSheet } from 'react-native-unistyles';
import Unicon from '@/components/General/Unicon';
import FollowUpNavTabs from '@/components/FollowUp/FollowUpNavTabs';

/**
 * Shared Follow Up page header — hero + module nav tabs. Every Follow Up tab
 * screen renders this so the module keeps one identity and one layout
 * (`children` slots in per-screen extras like the overview freshness line).
 */
const FollowUpHeader = ({ active, canManage = false, children }) => (
    <>
        <View style={styles.hero}>
            <View style={styles.heroIconContainer}>
                <Unicon name="user-round-arrow-left" size={28} colorVariant="onSecondary" />
            </View>
            <Text style={styles.heroTitle}>Follow Up</Text>
            <Text style={styles.heroDescription}>
                Keep people connected. See what needs your team next.
            </Text>
            {children}
        </View>
        <FollowUpNavTabs active={active} canManage={canManage} />
    </>
);

const styles = StyleSheet.create(({ colors, fonts }) => ({
    hero: { alignItems: 'center', paddingVertical: 12, gap: 8 },
    heroIconContainer: {
        width: 56,
        height: 56,
        borderRadius: 16,
        backgroundColor: colors.paths,
        alignItems: 'center',
        justifyContent: 'center',
    },
    heroTitle: { fontSize: 24, fontFamily: fonts.heading, color: colors.text, textAlign: 'center' },
    heroDescription: {
        fontSize: 14,
        fontFamily: fonts.body,
        color: colors.textSecondary,
        textAlign: 'center',
        maxWidth: 500,
        lineHeight: 20,
    },
}));

export default FollowUpHeader;
